import React from 'react';
import '../../../styles.scss';

import {configData} from "../../../config.js";
import {formatDate, convertToDate, fetchSigned} from '../../../shared/Utilities.js';
import AgreementList from '../../../components/useCase/AgreementList.js';
import SelectedReferenceList from '../../../components/general/SelectedReferenceList.js';

import {
  OwcTypography,  OwcExpandable,
  OwcTable, OwcTableHeader, OwcTableHeaderCell,
  OwcTableBody, OwcTableRow, OwcTableCell,
  OwcComponentHeader, OwcComponentFooter, OwcPagination
} from '@one/react';

/**
 * @copyright Roche 2025
 * @author Nick Draper
 */

/**
 * Specific control for displaying the Country overwiew
 */
class CountryReportOverwview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      overwiewExpanded: true,
      rowsPerPage: 10,
      page: 1,
      agreementList: [],
    }
  }

  async componentDidMount() {    // load the reference system type data
    this.loadAgreements();
  }

  loadAgreements() {
    if (this.props.report !== undefined &&
        this.props.report.countryReport !== undefined &&
        this.props.report.countryReport.data.appliedFilters !== undefined) {
      let idList = this.props.report.countryReport.data.appliedFilters.customerAgreementId;
      if ((idList === undefined) || (idList.trim() === "")) 
      {
        this.setState({agreementList: []});
      } else {
        // remove whitespace
        idList = idList.replace(/\s/g, "");
        //load the agreements
        const searchData = {
          searchBy: "Agreement ID",
          searchTerm: idList};
        fetchSigned(configData.USECASE_API_URL + "agreement-search/", {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(searchData)
        })
        .then(res => res.json())
        .then(
          (result) => {
            this.setState({agreementList: result});
          },
          // Note: it's important to handle errors here
          // instead of a catch() block so that we don't swallow
          // exceptions from actual bugs in components.
          (errorMsg) => {
            this.setState({
              isLoaded: true,
              error: "Error Loading data uses cases" + errorMsg
            });
          }
        )
      }
    } else {
        this.setState({agreementList: []});
    }
  }

  handlePaginationChange(ev) {
    let newPage = ev.detail.page;
    if (ev.detail.pageSize !== this.state.rowsPerPage) {
      newPage=1
    }
    if ((this.state.page !== newPage) || (ev.detail.pageSize !== this.state.rowsPerPage)) {
      this.setState({
          rowsPerPage: ev.detail.pageSize,
          page: newPage
        });
      }
  }

  renderDUPSummary() {
    const report = this.props.report.countryReport;
    const dupSummary = report.data.summary.dataUsePurposes;
    if (dupSummary === undefined) { 
      return("Summary Not Found");
    }

    return(
      <OwcTable key={"DUPSummaryTable"} size='dense' elevated>
        <OwcTableHeader sticky>
            <OwcTableHeaderCell key="titleDUPSummaryPurpose" resizable width="75%">Purpose</OwcTableHeaderCell>
            <OwcTableHeaderCell key="titleDUPSummaryCount" resizable width="25%">Device Count</OwcTableHeaderCell>
        </OwcTableHeader>
        <OwcTableBody>
          {dupSummary.map(item => this.renderDUPSummaryRow(item))}
        </OwcTableBody>
        <OwcComponentHeader slot="header">
          Data Use Purposes ({dupSummary.length})
        </OwcComponentHeader>
      </OwcTable>
    );
  }

  renderDUPSummaryRow(item) {
    const keyEnding = item.name;
    
    return (
      <OwcTableRow
          key={"rowDUPSummary" + keyEnding}
          id={"rowDUPSummary" + keyEnding}>
        <OwcTableCell 
            style={{wordBreak:"normal"}} 
            key={"DUPSummaryNameCell" + keyEnding} valign="middle">
            {item.description}
        </OwcTableCell>
        <OwcTableCell style={{wordBreak:"normal"}} 
            key={"DUPSummaryCountCell" + keyEnding} valign="middle">
          {item.deviceCount}
        </OwcTableCell>
      </OwcTableRow>
    );
  }

  renderDUSummary() {
    const report = this.props.report.countryReport;
    const duSummary = report.data.summary.dataUses;
    const totalPages = Math.ceil(duSummary.length / this.state.rowsPerPage);
    const firstDeviceIndex = (this.state.page-1) * this.state.rowsPerPage
    const lastDeviceIndex = firstDeviceIndex + this.state.rowsPerPage
    let tableTitle = "Data Uses"
    if (totalPages > 1) {
      tableTitle +=  ` (${firstDeviceIndex+1} to ${lastDeviceIndex>duSummary.length?duSummary.length:lastDeviceIndex} of ${duSummary.length})`
    } else {
      tableTitle +=  ` (${duSummary.length})`
    }
    if (duSummary === undefined) { 
      return("Summary Not Found");
    }
    let sortedArray = duSummary.toSorted((a, b) => a.dataUseId-b.dataUseId);

    return(
      <OwcTable key={"DUSummaryTable"} size='dense' elevated>
        <OwcTableHeader sticky>
            <OwcTableHeaderCell key="titleDUSummaryId" resizable width="25%">Data Use Id</OwcTableHeaderCell>
            <OwcTableHeaderCell key="titleDUSummaryPurpose" resizable width="50%">Name</OwcTableHeaderCell>
            <OwcTableHeaderCell key="titleDUSummaryCount" resizable width="25%">Device Count</OwcTableHeaderCell>
        </OwcTableHeader>
        <OwcTableBody>
          {sortedArray.map((item, index) => {if ((index >= firstDeviceIndex) &&
                                                  (index < lastDeviceIndex)) {
                                                return this.renderDUSummaryRow(item)
                                              } else { 
                                                return("") 
                                              }
                                            })}
        </OwcTableBody>
        <OwcComponentHeader slot="header">
          {tableTitle}
        </OwcComponentHeader>
        {totalPages>1
        ?
          <OwcComponentFooter slot="footer">
            <OwcPagination slot="suffix" pageSizeOptions={[10, 20, 50]}
              page={this.state.page}
              total={totalPages}
              pageSize={this.state.rowsPerPage}
              onPageChange={(ev)=>{this.handlePaginationChange(ev)}}
              >
              <div slot="rows-per-page"> Rows per Page </div>
            </OwcPagination>
          </OwcComponentFooter>
        :
          ""
        }
      </OwcTable>
    );
  }

  renderDUSummaryRow(item) {
    const keyEnding = item.name;
    
    return (
      <OwcTableRow
          key={"rowDUSummary" + keyEnding}
          id={"rowDUSummary" + keyEnding}>
        <OwcTableCell 
            style={{wordBreak:"normal"}} 
            key={"DUSummaryIdCell" + keyEnding} valign="middle">
            {item.dataUseId}
        </OwcTableCell>
          <OwcTableCell 
            style={{wordBreak:"normal"}} 
            key={"DUSummaryNameCell" + keyEnding} valign="middle">
            {item.name}
        </OwcTableCell>
        <OwcTableCell style={{wordBreak:"normal"}} 
            key={"DUSummaryCountCell" + keyEnding} valign="middle">
          {item.deviceCount}
        </OwcTableCell>
      </OwcTableRow>
    );
  }

  renderCountryList() {
    const report = this.props.report.countryReport;
    const countryList = report.data.appliedFilters.country;
    if (countryList !== undefined) {
      const countryListArray = countryList.split(",");
      // add zero width spaces to allow brasking of the long string
      const countryListWithTinySpaces = countryListArray.join(",\u{200B}");

      return(
        <>
          <OwcTypography variant="body" style={{fontWeight:"var(--one-text-font-weight-bold)"}}>Country Filter ({countryListArray.length} {countryListArray===1?"Country":"Countries"} Selected)</OwcTypography>
          <OwcTypography variant="body2" style={{marginLeft:"2em"}}>{countryListWithTinySpaces}</OwcTypography>
        </>
      );
    } else {
      return(
        <>
          <OwcTypography variant="body" style={{fontWeight:"var(--one-text-font-weight-bold)"}}>No Country Filter (All Countries Included)</OwcTypography>
        </>
      );
    }
  }

  renderFilterList() {
    const report = this.props.report.countryReport;
    const appliedFilters = report.data.appliedFilters;

    if (appliedFilters === undefined) {
      return;
    }

    const referenceSystemTypeFilter = appliedFilters?.referenceSystemType;
    const customerAgreementIdFilter = appliedFilters?.customerAgreementId;
    const knownFilters = ["customerAgreementId", "referenceSystemType", "country"];
    const deviceFilters = {...appliedFilters};
    //remove all the non device filters
    knownFilters.forEach(element=>{delete deviceFilters[element]});



    // get screen width
    let columnCount = 1;
    if (window.innerWidth > 800) {
      columnCount = 2;
    }
    if (window.innerWidth > 1200) {
      columnCount = 3;
    }
    
    return(
      <div style={{display:"flex", flexDirection:"column", marginLeft:"0em"}}>
        { customerAgreementIdFilter===undefined?
          <OwcTypography key={`referenceSystemTypeHeader`} variant="subtitle2">No Agreement Filter (All Agreements Included)</OwcTypography> 
        :
              <>
              <OwcTypography key={`referenceSystemTypeHeader`} variant="subtitle2">Agreement Filter ({customerAgreementIdFilter.replace(" ","").split(",").length} Selected)</OwcTypography>              <div style={{marginLeft:"1.5em"}}> 
                {this.renderAgreementList(columnCount)}
              </div>
              </>
        }
        {referenceSystemTypeFilter===undefined?
          <OwcTypography key={`referenceSystemTypeHeader`} variant="subtitle2">No Reference System Type Filter (All System Types Included)</OwcTypography> 
        :
              <>
              <OwcTypography key={`referenceSystemTypeHeader`} variant="subtitle2">Reference System Type Filter ({referenceSystemTypeFilter.replace(" ","").split(",").length} Selected)</OwcTypography>
              <div style={{marginLeft:"1.5em"}}> 
                <SelectedReferenceList  selectedRefDataList={referenceSystemTypeFilter.replace(" ","").split(",").map(Number)} hideTitle listTypographyVariant="body2"/>
              </div>
              </>
        }
        
        {Object.keys(deviceFilters).length===0?
          <OwcTypography key={`referenceSystemTypeHeader`} variant="subtitle2">No Device Filter</OwcTypography> 
        :
            <>
            <OwcTypography key={`referenceSystemTypeHeader`} variant="subtitle2">Device Filter ({Object.keys(deviceFilters).length} Selected)</OwcTypography>
            <div style={{marginLeft:"1.5em"}}> 
              {this.renderDeviceFilters(deviceFilters)}
            </div>
            </>
        }
      </div>
    );
  }

  renderDeviceFilters(deviceFilters) {
    const filterTranslationDict = {
      "serialNo": "Serial Number",
      "labId": "Lab ID",
      "accountNo": "Account Number",
      "instrumentLocation": "Device Location",
      "referenceSystemType": "Reference System Type",
      "customerAgreementId": "Customer Agreements",
    }
    return (
        <>
        {Object.keys(deviceFilters).map((key) => {
            const value = deviceFilters[key];
            return (
              <>
              <OwcTypography key={`${key}Header`} variant="subtitle2">{key in filterTranslationDict?filterTranslationDict[key]:key}</OwcTypography>
              <OwcTypography key={`${key}Value`} variant="body2" style={{marginLeft:"2em"}}>{value}</OwcTypography>
              </>
            );
          }
        )}
        </>
    );
    
  }


  renderAgreementList(columnCount) {
    if (columnCount === 1 || this.state.agreementList.length < 4) {
      return (
        <AgreementList 
          key="countryReportOverviewAgreementList1"
          agreementList={this.state.agreementList}
          keyPrefix="countryReportOverviewAgreementList1"
          showActionIcon={false}
          hideTitle={true}
        />
      );
    } else if ((columnCount === 2 || this.state.agreementList.length < 7)) {
      const half = Math.ceil(this.state.agreementList.length / 2);    

      const firstHalf = this.state.agreementList.slice(0, half)
      const secondHalf = this.state.agreementList.slice(half)
      return (
        <div style={{display: "flex", flexDirection:"row", gap: "2em"}}>
        <AgreementList style={{width:"300"}}
          key="countryReportOverviewAgreementList1"
          agreementList={firstHalf}
          keyPrefix="countryReportOverviewAgreementList1"
          showActionIcon={false}
          hideTitle={true}
        />
        <AgreementList  style={{width:"300"}}
          key="countryReportOverviewAgreementList2"
          agreementList={secondHalf}
          keyPrefix="countryReportOverviewAgreementList2"
          showActionIcon={false}
          hideTitle={true}
        />
        </div>
      );
    } else {
      const third = Math.ceil(this.state.agreementList.length / 3);    

      const firstThird = this.state.agreementList.slice(0, third)
      const middleThird = this.state.agreementList.slice(third, third*2)
      const lastThird = this.state.agreementList.slice(third*2)
      return (
        <div style={{display: "flex", flexDirection:"row", gap: "2em", justifyContent: ""}}>
        <AgreementList 
          key="countryReportOverviewAgreementList1"
          agreementList={firstThird}
          keyPrefix="countryReportOverviewAgreementList1"
          showActionIcon={false}
          hideTitle={true}
        />
        <AgreementList 
          key="countryReportOverviewAgreementList2"
          agreementList={middleThird}
          keyPrefix="countryReportOverviewAgreementList2"
          showActionIcon={false}
          hideTitle={true}
        />
        <AgreementList 
          key="countryReportOverviewAgreementList3"
          agreementList={lastThird}
          keyPrefix="countryReportOverviewAgreementList3"
          showActionIcon={false}
          hideTitle={true}
        />
        </div>
      );
    }
  }

  /**
  * Renders the specification section for the Data Product
  * @returns formatted JSX
  */
  render() {
    const report = this.props.report.countryReport;
    return (
      <div style={{ marginLeft: "2em", marginRight: "2em"}}>
        <OwcExpandable roundedControl variant="transparent"
            expanded={this.state.overwiewExpanded}
            onExpandedChange={(ev) => { this.setState({ overwiewExpanded: ev.detail }) }}>
          <span slot="title">
            <OwcTypography variant="title6">
              Report Overview - Created on {formatDate(convertToDate(report.dataProductLabel.queryTime), true)} UTC
            </OwcTypography>
          </span>
          <span slot="content">
            <OwcTypography variant="title6">Report Filters</OwcTypography>
            <div style={{display:"flex", flexDirection:"column"}}>
              {this.renderCountryList()}
              {this.renderFilterList()}

            </div>
            <hr/>
            <OwcTypography variant="title6">Report Summary</OwcTypography>

            <div style={{display:"flex", flexDirection:"row", alignItems:"flex-start", justifyContent: "space-between", gap: "2em"}}>
              {this.renderDUPSummary()}
              {this.renderDUSummary()}
            </div>
          </span>
        </OwcExpandable>
      </div>
    );
  }
}

export default CountryReportOverwview;
